import axios from "axios";
const API = process.env.REACT_APP_NODEJS_SERVER_URL;
const auth = () => ({ headers: { accessToken: localStorage.getItem("accessToken") } });

export async function getCommissionSummary(orderId) {
  const { data } = await axios.get(`${API}/commissions/${orderId}/summary`, auth());
  return data;
}
export async function getCommissionHistory(orderId) {
  const { data } = await axios.get(`${API}/commissions/${orderId}/history`, auth());
  return data.history || [];
}
export async function approveCommission(orderId, payload) {
  const { data } = await axios.post(`${API}/commissions/${orderId}/approve`, payload, auth());
  return data;
}
export async function payCommission(orderId, payload) {
  const { data } = await axios.post(`${API}/commissions/${orderId}/pay`, payload, auth());
  return data;
}

export async function createManualCommission(orderId, payload) {
  const { data } = await axios.post(`${API}/commissions/${orderId}/manual`, payload, auth());
  return data;
}

export async function regenerateCommission(orderId, payload = {}) {
  const { data } = await axios.post(`${API}/commissions/${orderId}/regenerate`, payload, auth());
  return data;
}

export async function updateCommissionPayout(orderId, commissionId, payload) {
  const { data } = await axios.patch(`${API}/commissions/${orderId}/payout/${commissionId}`, payload, auth());
  return data;
}
